/*
Section reveals.

Every beat is a full screen, so a 20px fade is invisible. These carry real
travel: the heading block rises and settles, then the grid below it comes in as
a stagger. Transform and opacity only.
*/

const HEADS = '.shell > h2, .shell > .horizon, .shell > p, .shell > .btn, .principles__head';
const CELLS = '.bento .tile, .clients__plate, .control__item, .fact, .contact__row, .field__frame, .principle, .delivers__cell, .specs__table tr, .intention__body p, .proceeds__panel';

export function reveal(gsap) {
  gsap.utils.toArray('[class*="beat-"]').forEach((beat) => {
    const heads = beat.querySelectorAll(HEADS);
    const cells = beat.querySelectorAll(CELLS);

    if (heads.length) {
      gsap.fromTo(heads, { y: 54, opacity: 0 }, {
        y: 0,
        opacity: 1,
        duration: 1.05,
        ease: 'power3.out',
        stagger: 0.09,
        clearProps: 'transform',
        scrollTrigger: { trigger: beat, start: 'top 72%', once: true },
      });
    }

    if (!cells.length) return;

    gsap.fromTo(cells, { y: 62, opacity: 0 }, {
      y: 0,
      opacity: 1,
      duration: 1,
      ease: 'power3.out',
      stagger: 0.075,
      clearProps: 'transform',
      scrollTrigger: { trigger: cells[0], start: 'top 88%', once: true },
    });
  });
}
